import { Backdrop, CircularProgress, Typography, Box } from "@mui/material";

const FullScreenLoader = ({ message }) => (
  <Backdrop
    open={true}
    sx={{
      zIndex: (theme) => theme.zIndex.drawer + 9999,
      color: "#fff",
      backdropFilter: "blur(4px)",
    }}
  >
    <Box sx={{ textAlign: "center", bgcolor: "white", p: 4, borderRadius: 2 }}>
      <CircularProgress sx={{ color: "#059669" }} />
      <Typography sx={{ mt: 2, color: "black" }}>{message}</Typography>
    </Box>
  </Backdrop>
);

export default FullScreenLoader;
